import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { CloseRounded } from '@mui/icons-material'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Dispatch, SetStateAction } from 'react'
import { deleteNovelty } from '../../../../../../redux/actions/novelties'
import { CancelButton, DeleteButton } from '../../../../../shared/components/inputs'

interface NoveltiesDialogDeleteProps {
  openDeleteNovelty: boolean
  setOpenDeleteNovelty: Dispatch<SetStateAction<boolean>>
  noveltySelected: any
  isMobile: boolean
  formClasses: any
}

const NoveltiesDialogDelete = ({
  openDeleteNovelty,
  setOpenDeleteNovelty,
  noveltySelected,
  isMobile,
  formClasses
}: NoveltiesDialogDeleteProps) => {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  const handleDelete = () => {
    dispatch(deleteNovelty(noveltySelected))
    setOpenDeleteNovelty(!openDeleteNovelty)
  }

  return (
    <Dialog
      open={openDeleteNovelty}
      fullWidth
      fullScreen={isMobile}
      maxWidth={isMobile ? undefined : 'sm'}
      sx={formClasses.containerForm}
      onClose={() => setOpenDeleteNovelty(!openDeleteNovelty)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">
            {t('delete')} {t('document')}
          </Typography>
          <Button onClick={() => setOpenDeleteNovelty(!openDeleteNovelty)} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent sx={formClasses.bodyForm}>
        <Grid container alignItems="flex-start" spacing={2}>
          <Grid item xs={12}>
            <Typography>{t('admin.novelties.delete-novelty-text')}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={() => setOpenDeleteNovelty(!openDeleteNovelty)}>{t('cancel')}</CancelButton>
        <DeleteButton autoFocus id="btn-handleldelete" onClick={handleDelete}>
          {t('delete')}
        </DeleteButton>
      </DialogActions>
    </Dialog>
  )
}

export default NoveltiesDialogDelete
